/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationBareLogPreviewItemDto } from './OrganizationBareLogPreviewItemDto';
import {
    OrganizationBareLogPreviewItemDtoFromJSON,
    OrganizationBareLogPreviewItemDtoFromJSONTyped,
    OrganizationBareLogPreviewItemDtoToJSON,
    OrganizationBareLogPreviewItemDtoToJSONTyped,
} from './OrganizationBareLogPreviewItemDto';

/**
 * 
 * @export
 * @interface PaginatedOrganizationBareLogsResponseDto
 */
export interface PaginatedOrganizationBareLogsResponseDto {
    /**
     * 
     * @type {Array<OrganizationBareLogPreviewItemDto>}
     * @memberof PaginatedOrganizationBareLogsResponseDto
     */
    items: Array<OrganizationBareLogPreviewItemDto>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOrganizationBareLogsResponseDto
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOrganizationBareLogsResponseDto
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOrganizationBareLogsResponseDto
     */
    limit: number;
}

/**
 * Check if a given object implements the PaginatedOrganizationBareLogsResponseDto interface.
 */
export function instanceOfPaginatedOrganizationBareLogsResponseDto(value: object): value is PaginatedOrganizationBareLogsResponseDto {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function PaginatedOrganizationBareLogsResponseDtoFromJSON(json: any): PaginatedOrganizationBareLogsResponseDto {
    return PaginatedOrganizationBareLogsResponseDtoFromJSONTyped(json, false);
}

export function PaginatedOrganizationBareLogsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedOrganizationBareLogsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(OrganizationBareLogPreviewItemDtoFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
    };
}

export function PaginatedOrganizationBareLogsResponseDtoToJSON(json: any): PaginatedOrganizationBareLogsResponseDto {
    return PaginatedOrganizationBareLogsResponseDtoToJSONTyped(json, false);
}

export function PaginatedOrganizationBareLogsResponseDtoToJSONTyped(value?: PaginatedOrganizationBareLogsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(OrganizationBareLogPreviewItemDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
    };
}

